// 15.E: тарифный пейволл на проверке. Вместо просто текста — CTA «Оплатить и
// запустить», открывающий модал оплаты ПРЯМО с заблокированной проверки (момент
// ценности → выше конверсия). Кнопка оплаты — только заказчику (плательщик);
// куратор/админ видят причину, но активируют вручную.
import { useState } from 'react';
import { CreditCard } from 'lucide-react';
import { PaymentModal } from '@/components/PaymentModal';
import { useAuth } from '@/state/auth';

export function PayGateBanner({ projectId, reason }: { projectId: string; reason: string }) {
  const [open, setOpen] = useState(false);
  const role = useAuth((s) => s.activeRole);
  const canPay = role === 'customer';
  return (
    <>
      {open && <PaymentModal projectId={projectId} onClose={() => setOpen(false)} />}
      <div style={{
        margin: '10px 0', padding: '12px 14px', borderRadius: 10,
        background: '#FFFBEB', border: '1px solid #FDE68A', color: '#92400E',
        fontSize: 13, lineHeight: 1.5, maxWidth: 720,
        display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      }}>
        <span style={{ flex: 1, minWidth: 220 }}>{reason}</span>
        {canPay && (
          <button type="button" onClick={() => setOpen(true)}
            style={{
              padding: '7px 16px', borderRadius: 9, fontSize: 13, fontWeight: 600,
              background: '#0A1628', color: '#fff', border: 'none', cursor: 'pointer',
              display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
            }}>
            <CreditCard size={14} /> Оплатить и запустить
          </button>
        )}
      </div>
    </>
  );
}
